<template>
  <div id="" class="all_table_box">
    <div class="check_btn_box">
      <span><i>{{multiple}}</i>{{$t('base.selected')}}</span>
      <div class="check_btn" :class="multiple>0?'on':''" @click="MessageBox(0)">{{$t('base.haveRead')}}</div>
      <div v-if="showType!='scheduled'" class="check_btn" :class="multiple>0?'on':''" @click="MessageBox(1)">{{$t('base.delete')}}</div>
    </div>
    <el-table ref="multipleTable" :data="list" class="table_box" @sort-change="SortChange" @selection-change="SelectionChange">
      <el-table-column type="selection" width="60" class-name="all_check"></el-table-column>
      <el-table-column :label="$t('base.status')" align="left" prop="State" width="100">
        <template slot-scope="scope">
          <span :class="scope.row.IsRead?'text_gray':'text_red'">{{ scope.row.IsRead?$t('base.haveRead'):$t('base.unread') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.title')" align="left" width="300">
        <template slot-scope="scope">
          <span  class="overflow_h" @click="goto(scope.row)">{{ scope.row.Title}}</span>
          <!-- <span v-if="scope.row.SendType==9" class="overflow_h" @click="dialog(scope.row,'safeguard')">{{ scope.row.Title}}</span> -->
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.information')" align="left" width="400">
        <template slot-scope="scope">
          <div class="com_box">
            <template v-if="msgTabs==10">
              <p class="overflow_h" @click="goto(scope.row)">{{ scope.row.EBody }}</p>
            </template>
            <template v-else>
              <p class="overflow_h" @click="goto(scope.row)">{{ scope.row.Body }}</p>
            </template>

            <!-- <p v-if="scope.row.SendType==9" class="overflow_h" @click="dialog(scope.row,'safeguard')">{{ scope.row.Body }}</p> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.createTime')" align="left" prop="Time" width="180">
        <template slot-scope="scope">
          <!-- <span class="" v-html='toSetTime(scope.row.CreateDate)'></span> -->
          <span>{{scope.row.CreateDate|setTime}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('base.operate')" width="160" align="left" class-name="all_operate">
        <template slot-scope="scope">
          <!-- <router-link class="more" :to="{path:'/messages/detail/'+scope.row.ID}">View Details</router-link> -->
          <div class="more" @click="goto(scope.row)">{{$t('base.viewDetails')}}</div>
          <!-- <div v-if="scope.row.SendType==9" class="more" @click="dialog(scope.row,'safeguard')">{{$t('base.viewDetails')}}</div> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 维权弹框 SafeGuard-->
    <safe-guard :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.safeguard' :userInfo='userInfo' @closeDialog="closeDialog" v-if='dislogType.safeguard' />
    <!-- 卖家议价历史 OfferHistory-->
    <offer-history :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.offerhistory' :userInfo='userInfo' @closeDialog="closeDialog" v-if='dislogType.offerhistory' />
  </div>
</template>
<script>
import SafeGuard from "@/components/dialog/safeguard"; // 维权
import OfferHistory from "@/components/dialog/offerhistory"; // 维权
import { getInfo, getTime } from "@/api/public";
import qs from 'qs'
export default {
  name: 'watchlistcheck',
  components: {
    SafeGuard,
    OfferHistory
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 19,
      },
      multiple: 0,
      multipleSelection: [],
      userInfo: null,
      dialogTitle: this.$t('base.disputed'),
      dialogList: null,
      dialogStyle: '',
      dialogVisible: false,
      dialogBox: 'dialogBoxPro pro',
      EquityVal: '',
      progress: {},
      lists: {},
      ifHeadPortrait: false,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  props: {
    list: {},
    msgTabs:String,
    showType: String,
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimeY(val) {
      return getTime(val, -8, 3, 'cn').split('|')[0]
    },
    setTimeYY(val) {
      return getTime(val, -8, 3, 'cn').split('|')[1]
    }
  },
  created() {
    //console.log(this.list, '11111')
    this.userInfo = getInfo()
  },
  methods: {

    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      this.$emit('update')
    },
    // toSetTime(val) {
    //   let time = getTime(val, -8, 3, 'cn').split('|')
    //   return time[0] + '<br/>' + time[1]
    // },
    // //获取输入长度
    // inputthandle({target}){
    //   const that= this
    //   that.EquityVal = target.value
    //   console.log(222,that.EquityVal.length)
    //   if(that.EquityVal.length>5){
    //     this.$refs.send.$el.style.background='#5F6DAE'
    //   }
    //   else{
    //     this.$refs.send.$el.style.background='#afb6d7'
    //   }
    // },
    goto(obj) {
      const that = this
      if(obj.SendType==9){
        that.dialog(obj,'safeguard')
        return
      }
      that.SetRead(obj)
      let SendType = obj.SendType
      let url = '';
      if (SendType == 4 && (obj.CreateUser != obj.ReceiveUserID)) {
        that.dialogTitle = that.$t('title.viewHistory');
        that.dialogBox = ""
        that.dislogType['offerhistory'] = true;
        that.dialogList = JSON.parse(JSON.stringify(obj));
      } else {
        if (SendType == 0) {
          url = '/messages/detail/'
        } else if (SendType == 1) {
          url = '/mycardhobby/detail/'
        } else if (SendType == 3) {
          url = '/carddetails/'
        } else if (SendType == 4) {
          url = '/mycardhobby/offerhistory/'
        } else if (SendType == 5) {
          url = '/mycardhobby/bidhistory/'
        } else if (SendType == 8) {
          url = '/messages/detail/'
        } else if (SendType == 11) { //转运订单
          //url = '/mycardhobby/waredetail/'
          url = '/mycardhobby/waredetail/'
        }else if(SendType == 16){
          //vault入库列表
          url='/vault/StockInApply?type=view&id='
        }else if(SendType == 17){
          //vault在库列表
          url='/vault/myvault/'
        }else if(SendType == 18){
          //vault流拍
          url='/vaultdetails/'
        }else if(SendType == 19){
          //vault流拍
          url='/mycardhobby/warehouse?AgencyId='
        }
        //ID
        if(obj.RelationStringID){
          url = url + obj.RelationStringID
        }else{
          url = url + obj.RelationID
        }
        // if (SendType == 11) {
        //   //url = url + obj.RelationStringID
        //   url = url
        // } else {
        //   url = url + obj.RelationID
        // }

        if (obj.seller) {
          var sellerUrl = process.env.VUE_APP_SELL_URL
          // 卖家跳转
          if (SendType == 1) {
            url = sellerUrl + "/#/orders/detail?id=" + obj.RelationID
            window.open(url)
          } else if (SendType == 4) {
            url = sellerUrl + "/#/commodity/Active/Auction"
            window.open(url)
          } else if (SendType == 5) {
            url = sellerUrl + "/#/commodity/Offer"
            window.open(url)
          } else {
            that.$router.push({
              path: url
            })
          }

        } else {

          that.getMessages(obj, SendType, url)
          // // 买家跳转
          // that.$router.push({
          //   path: url
          // })
        }
      }
    },
    getMessages(obj, SendType, url) {
      let that = this;
      if (SendType == 1) {
        let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, orderId: obj.RelationID }
        that.$get(that.$interface.OrdersDetail, data).then(res => {
          if (res.result != 0) {
            let result = res.data
            if (result.SellerWyAccId == that.userInfo.MappingUserId) {
              obj.seller=true
              that.goto(obj)
            } else {
              that.toRouter(url)
            }
          }else{
            that.$message({
            type: 'error',
            message: res.msg
          });
            }
        })
      } else {
        that.toRouter(url)
      }
    },
    toRouter(url) {
      this.$router.push({
        path: url
      })
    },
    SetRead(obj) {
      let that = this;
      let data = { token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, id: obj.ID }
      this.$post(this.$interface.NotificationSetRead, qs.stringify(data)).then(res => {})
    },
    dialog(obj, val) {
      this.SetRead(obj)
      let that = this;
      that.$emit('update')
      if (val == 'safeguard') {
        //that.GetSafe(obj)
        that.dialogTitle = that.$t('base.disputed');
        that.dialogBox = "dialogBoxPro pro"
        that.dislogType[val] = true
        that.dialogList = JSON.parse(JSON.stringify(obj));
      }
      // console.log(obj)
      // if (val == 'pro') {
      //   that.GetSearchSell(obj)
      //   that.GetSafe(obj)
      //   that.dialogTitle = "Details";
      //   that.dialogStyle = 'pro';
      //   that.dialogBox = "dialogBoxPro"
      // }
      // that.dialogList = obj;
      // that.dialogVisible = true;
    },

    // EquitySave() {
    //   // 维权
    //   let that = this;
    //   let _imageUrl = that.$refs.UploadImages.picList;
    //   let imgs = '';
    //   if (_imageUrl.length) {
    //     _imageUrl.map((obj, k) => {
    //       let cut = k < _imageUrl.length - 1 ? ',' : '';
    //       imgs += obj['ImageUrl'] + cut;
    //     });
    //   }
    //   var data = { 'OrderID': that.dialogList.ID, "Title": that.EquityVal, 'Images': imgs, 'token': that.userInfo.ChineseToken, 'memberId': that.userInfo.MappingUserId, 'operator_id': that.userInfo.MappingUserId}
    //   this.$post(this.$interface.AddSafeRight, qs.stringify(data)).then(res => {
    //       console.log("axios-res:", res);
    //       let _type = 'success';
    //       if (res.result != 1) {
    //         _type = 'error';
    //       } else {
    //         that.$message({
    //           showClose: true,
    //           message: res.msg || _type,
    //           type: _type,
    //         });
    //         setTimeout(() => {
    //           that.$refs.UploadImages.picList = [];
    //           that.EquityVal = '';
    //           that.imgs = '';
    //           that.OfferShow = false;
    //         }, 1000);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // handleClose() {
    //   this.dialogVisible = false
    // },
    // GetSafe(obj) {
    //   // 获取维权列表
    //   let that = this;
    //   let data = { orderId: obj.RelationID, pageIndex: 1, applyType: 0, token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId }
    //   this.$get(this.$interface.GetSafeRights, data).then(res => {
    //     that.progress = res.data;
    //   })
    // },
    // GetSearchSell(obj) {
    //   // 获取订单详情
    //   let that = this;
    //   let data = { OrderID: obj.RelationID, operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken }
    //   this.$get(this.$interface.OrdersDetail, data).then(res => {
    //     if (res.result != 0) {
    //       let result = res.data;

    //       that.dialogList = result;
    //     }
    //   })
    // },



    SelectionChange(val) {
      this.multipleSelection = val;
      this.multiple = this.multipleSelection.length
      //console.log(this.multipleSelection)
    },
    SortChange(val) {
      //ascending 表示升序，descending 表示降序，null 表示还原为原始顺序
      let sort = val.order;
      let sortName = val.prop;
      //console.log(sort, sortName)
    },
    // val 0:批量已读，1:批量删除
    MessageBox(val, obj) {
      let that = this
      var multipleSelection = [];
      let title = val != 1 ? that.$t('base.upload') : that.$t('base.delete');
      let msg = '';
      if (obj == undefined) {
        multipleSelection = this.multipleSelection;
        if (val != 1) {
          msg = '<div class="p_txt">' + that.$t('alert.doYouUploadFor') + multipleSelection.length + that.$t('base.items') + '?</div>';
        } else {
          msg = '<div class="p_txt">' + that.$t('alert.doYouDeleteThese') + multipleSelection.length + that.$t('base.items') + '?</div>';
        }
      } else {
        //data.push(obj);
        if (val != 1) {
          msg = '<div class="p_txt">' + that.$t('alert.doYouUplod') + '</div>';
        } else {
          msg = '<div class="p_txt">' + that.$t('alert.doYouDelete') + '</div>';
        }
      }
      if (multipleSelection.length > 0) {
        this.$confirm(msg, title, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: that.$t('base.yes'),
          cancelButtonText: that.$t('base.no'),
          lockScroll: false
        }).then(() => {
          let ids = []
          let url = this.$interface.DeleteMessgaes
          let data = ""
          if (val != 1) {
            url = this.$interface.NotificationSetReads
            multipleSelection.map(item => {
              if (!item.IsRead) {
                ids.push(item.ID)
              }
            })
          } else {
            multipleSelection.map(item => {
              ids.push(item.ID)
            })
          }
          data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, Ids: ids }
          that.$post(url, qs.stringify(data)).then(res => {
            if (res.result != 0) {
              that.$emit('update')
            }
          })
        }).catch(() => {});
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";

/deep/ .pro {
  margin-top: -5vh;
}

/deep/ .pro .el-dialog__body {
  padding: 12px;
  background: #f7f7f7;
  height: 65%;
}

.bg {
  background: #fff;
}

.like_slide {
  width: 88px;
  height: 88px;
}

.img-block {
  padding-bottom: 5px;
}

.title_color1 {
  color: #a0a0a0;
}

.time {
  text-align: center;
  width: 100%;
  display: block;
  padding: 16px 0;
}

.pro_list {
  height: 100%;
  overflow-y: scroll;
  margin: 8px 0 0;
}

.commodity_index_box,
.Process_box,
.seller_reply,
.user_reply {
  display: flex;
}

.commodity_index_box {
  padding: 0 0 12px 0;
}

.Process_box {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
}

.commodity_index {
  position: relative;
  padding: 0 12px;
  width: 396px;
}

.commodity_img {
  width: 88px;
  height: 88px;
  border-radius: 3px;
}

.commodity_img img {
  width: 88px;
  height: 88px;
  border-radius: 3px;
  object-fit: contain;
}

.commodity_title {
  font-size: 16px;
  font-weight: 500;
}

.Order_price {
  height: 32px;
  font-size: 17px;
  line-height: 45px;
  overflow: hidden;
}

.Process {
  height: 32px;
  font-size: 12px;
  padding: 9px 12px;
  display: inline-block;
  background: #f7f7f7;
  margin: 0 12px 0 0;
}

.Processing_box {
  height: 100%;
  overflow-y: scroll;
  margin: 8px 0 0;
}

.seller_img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.seller_reply img,
.user_reply img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.seller_reply,
.user_reply {
  margin: 0 0 16px 0;
}

.seller_reply .text,
.user_reply .text {
  min-height: 40px;
  max-width: 332px;
  background: #ffffff;
  z-index: 2;
  margin: 0 0 0 -6px;
  padding: 0 12px;
}

.text span {
  display: block;
  padding: 12px 0;
}

.most {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  content: "";
  border-left: 0;
  border-top: 0;
  z-index: 1;
  margin: 12px 0;
}

.seller_reply_box {
  min-height: 40px;
  display: flex;
  margin: 0 0 0 10px;
}

.user_reply_box {
  display: flex;
  min-height: 40px;
  margin: 0 10px 0 0;
}

.user_reply_box .most {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  content: "";
  border-left: 0;
  border-top: 0;
  z-index: 1;
  margin: 12px 0px 12px -6px;
}

.text img {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin: 0 4px 0 0;
}

.text_img {
  max-height: 100px;
  padding: 0 0 12px 0;
}

.user_reply {
  justify-content: end;
  flex-direction: row-reverse;
}

.send {
  background: #afb6d7;
  color: #fff;
  border: none;
  position: absolute;
  right: 0;
}

.send_box {
  padding: 0 12px 0 0;
  background: #ffffff;
  position: relative;
}

.offerEquity-box {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dialogDatapro {
  height: 100%;
  background: #f7f7f7;
}

.pro_list_detail>div {
  display: flex;
  margin: 10px auto;
}

.pro_list_detail>div .like_box {
  display: flex;
}

.pro_list_detail>div .like_img {
  width: 88px;
  height: 88px;
  background-color: #f7f7f7;
  border-radius: 3px;
  margin-right: 12px;
}

.check_btn_box {
  display: flex;
  line-height: 30px;
  padding: 20px 0;
}

.check_btn_box i {
  color: #5F6DAE;
  margin-right: 2px;

}

.check_btn {
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  color: #C8C8C8;
  border-radius: 4px;
  margin-left: 12px;
  border: 1px solid #C8C8C8;
  cursor: pointer;
}

.check_btn.on {
  color: #5F6DAE;
  border-color: #5F6DAE;
}

.more {
  cursor: pointer;
}

.overflow_h {
  word-break: break-word;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  cursor: pointer;
}

/deep/ .el-checkbox__inner {
  border: 1px solid #a0a0a0;
}

/deep/.el-table tr th,
/deep/ .el-table__row td {
  padding: 0;
}

/deep/.el-table .has-gutter,
/deep/.el-table tr {
  height: 48px;
}

/deep/.el-table .cell {
  line-height: 18px;
  color: #333;
}

</style>



// WEBPACK FOOTER //
// src/components/list/messages.vue